import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      "fill-rule": "evenodd",
      d: "M10.434 5.762h2.56c.085.086.091.518.091.64v6.628c0 .756-.615 1.372-1.371 1.372H4.285a1.373 1.373 0 0 1-1.37-1.372V2.973c0-.756.614-1.371 1.37-1.371h3.883c.146 0 .584-.001.666.08v2.48a1.6 1.6 0 0 0 1.6 1.6m-2.428.6-.084.005a.667.667 0 0 0 0 1.324L8 7.695l.084-.004a.667.667 0 0 0 0-1.324zm-.006 2h-.667l-.078.005a.667.667 0 0 0 0 1.324l.078.004v2l.005.078a.666.666 0 0 0 .584.584l.078.005h.666l.078-.005a.666.666 0 0 0 .584-.584l.005-.078-.005-.078a.67.67 0 0 0-.509-.571l-.075-.013-.078-.004v-2l-.004-.078a.67.67 0 0 0-.584-.584z",
      "clip-rule": "evenodd",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6E6E7D",
      d: "M9.795 4.402v-2.48l2.88 2.88h-2.48a.4.4 0 0 1-.4-.4",
      style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }